import { Component, ViewChild, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { EmailService } from './email.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Email } from './email.model';
import { Subscription } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';
import { UtilsService } from '../../../service/helper/utils.service';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['style.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ]
})
export class EmailComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('start', { read: MatInput, static: false }) start: MatInput;
  @ViewChild('end', { read: MatInput, static: false }) end: MatInput;

  private subscription: Subscription;
  dataSource: MatTableDataSource<Email>;
  pageSize = 50;
  itemCount = 1000;
  profile: string;
  filterSelectObj = [];
  filter = { message: '', plantid: '', available: '', start: 0, end: 0, card: '', email: '' };
  displayedColumns: string[] = ['timestamp', 'plantid', 'message', 'available', 'card', 'email'];

  constructor(
    private authenticationService: AuthenticationService,
    private emailService: EmailService,
    private changeDetectorRefs: ChangeDetectorRef,
    private storageService: ApiService,
    private utilsService: UtilsService
  ) {
    this.filterSelectObj = [
      { name: 'Data/Ora', columnProp: 'timestamp', options: [] },
      { name: 'ID impianto', columnProp: 'plantid', options: [] },
      { name: 'Messaggio', columnProp: 'message', options: [] },
      { name: 'Reperibile', columnProp: 'available', options: [] },
      { name: 'Tessera', columnProp: 'card', options: [] },
      { name: 'Email', columnProp: 'email', options: [] }
    ];
  }

  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  updateEnd(end) {
    this.filter["end"] = (new Date(end._selected._d)).getTime();
    this.getData(0, this.pageSize, this.filter);
  }

  updateStart(start) {
    this.filter["start"] = (new Date(start._selected._d)).getTime();
    this.getData(0, this.pageSize, this.filter);
  }

  getServerData(event?: PageEvent) {
    this.getData(event.pageIndex, event.pageSize, this.filter);
  }

  filterChange(filter, event) {
    this.filter[filter.columnProp] = filter.modelValue;
    this.getData(0, this.pageSize, this.filter);
  }

  resetFilters() {
    this.filter = { message: '', plantid: '', available: '', start: 0, end: 0, card: '', email: '' };
    this.filterSelectObj.forEach(value => value.modelValue = undefined);
    this.dataSource.filter = '';
    this.start.value = '';
    this.end.value = '';
    this.getData(0, this.pageSize, []);
  }

  createFilter() {
    return (data: any, filter: string): boolean => {
      const searchTerms = JSON.parse(filter);
      return Object.keys(searchTerms).every(col => !searchTerms[col] || data[col] === searchTerms[col]);
    };
  }

  getData(pageIndex, pageSize, filter) {
    this.utilsService.showLoader();
    this.profile = this.authenticationService.currentUserValue.profile;
    this.storageService.getEmail(pageIndex, pageSize, filter);
    this.itemCount = parseInt(this.emailService.getEmailcount());
    this.dataSource = new MatTableDataSource(this.emailService.getEmail());

    this.subscription = this.emailService.emailChanged.subscribe((emails: Email[]) => {
      this.dataSource = new MatTableDataSource(emails);
      this.dataSource.sort = this.sort;
      this.changeDetectorRefs.detectChanges();
      this.utilsService.hideLoader();
      this.dataSource.filterPredicate = this.createFilter();
      this.changeDetectorRefs.detectChanges();
    });

    this.subscription.add(
      this.emailService.emailcountChanged.subscribe((emailcount: string) => {
        this.itemCount = parseInt(emailcount);
      })
    );
  }

  ngOnInit() {
    this.storageService.getEmailColumn().subscribe(v => {
      this.filterSelectObj.forEach(o => {
        if (o.columnProp !== 'timestamp') o.options = v[o.columnProp].sort();
      });
    });

    this.storageService.getEmailcount();
    this.getData(0, this.pageSize, []);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  downloadFile(data, filename = 'data') {
    const csvData = this.ConvertToCSV(data, this.displayedColumns);
    const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement("a");
    const url = URL.createObjectURL(blob);

    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
      dwldLink.setAttribute("target", "_blank");
    }

    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray, headerList) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(v => { delete v.id; delete v.timestamp; });

    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}\r\n`;
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}\r\n`;
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''));
  }

  download() {
    this.downloadFile(this.emailService.getEmail(), 'stato_chiamate');
  }
}
